// App Configuration
// Change APP_NAME to update branding throughout the application
export const APP_NAME = 'UserInsight.live'
export const APP_DOMAIN = 'userinsight.live'

// Plan limits
export const PLAN_LIMITS = {
  sessionsPerMonth: 5000,
  eventsPerMonth: 100000,
  dataRetentionDays: 30,
  // No limit on sites - users can add as many domains as they want
  // Usage limits are shared across all sites in the account
}

// Pricing
export const PRICING = {
  monthlyPrice: 10, // EUR
  trialDays: 7,
  currency: 'EUR',
}

// API endpoints
export const API_BASE_URL = import.meta.env.VITE_API_URL || ''
export const TRACKER_URL = import.meta.env.VITE_TRACKER_URL || ''

// Supabase
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || ''
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

// Stripe
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''
